import { getObsTokenReq } from '@/api/global';
import OSS from 'ali-oss';

const obsDownloadFile = async function (bucketName, objectKey) {
        let finalRes = null;
        const { data, code } = await getObsTokenReq();
        if (code === '00000') {
            let obj = {
                // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                region: 'oss-cn-beijing',
                authorizationV4: true,
                // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                accessKeyId: data.access_key_id,
                accessKeySecret: data.access_key_secret,
                // 从STS服务获取的安全令牌（SecurityToken）。
                stsToken: data.security_token,
                // 填写Bucket名称。
                bucket: bucketName
            };
            const client = new OSS(obj);
            const res = await client.get(objectKey);
            if (res && res.content) {
                const decoder = new TextDecoder('utf-8');
                const jsonString = decoder.decode(res.content);
                finalRes = JSON.parse(jsonString);
            }

            return finalRes;
        }
    },
    obsDownloadFileSaveByType = async function (bucketName, objectKey) {
        const { data, code } = await getObsTokenReq();
        if (code === '00000') {
            const client = new OSS({
                // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                region: 'oss-cn-beijing',
                authorizationV4: true,
                // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                accessKeyId: data.access_key_id,
                accessKeySecret: data.access_key_secret,
                // 从STS服务获取的安全令牌（SecurityToken）。
                stsToken: data.security_token,
                // 填写Bucket名称。
                bucket: bucketName
            });
            const url = client.signatureUrl(objectKey, {});
            return url;
        }
    };

export { obsDownloadFile, obsDownloadFileSaveByType };
